@if (verfahren | async; as _verfahren) {
	<div class="c-areas" data-test-id="verfahrensbaum-root" (keydown)="switchFocus($event)" data-help-anchor="_die_verfahrensansicht">
		<div class="c-areas__area">
			<schir-int-client-vorgaenge-in-verfahren class="x-section"
			                                         [verfahren]="_verfahren" data-test-id="vorgaenge-in-verfahren"
		data-help-anchor="_spalte_vorgaenge"
			/>
			<router-outlet name="vorgang"/>
			<router-outlet name="verfuegung"/>
			<router-outlet name="aufgabe"/>
		</div>
		<div class="c-areas__area">
			<schir-int-client-kontakt-list-container/>
		</div>
	</div>
}
